import { render, staticRenderFns } from "./LogOutButton.vue?vue&type=template&id=9cbd4352&scoped=true&"
import script from "./LogOutButton.vue?vue&type=script&lang=js&"
export * from "./LogOutButton.vue?vue&type=script&lang=js&"
import style0 from "./LogOutButton.vue?vue&type=style&index=0&id=9cbd4352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbd4352",
  null
  
)

export default component.exports